 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTPHOTO from '@/components/Text/photo'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTEPIGRAPHS from '@/components/Text/epigraphs'
 import TEXTPROLOGUE from '@/components/Text/prologue'
 import TEXTCH1 from '@/components/Text/ch1'
 import TEXTCH2 from '@/components/Text/ch2'
 import TEXTCH3 from '@/components/Text/ch3'
 import TEXTCH4 from '@/components/Text/ch4'
 import TEXTCH5 from '@/components/Text/ch5'
 import TEXTCH6 from '@/components/Text/ch6'
 import TEXTCH7 from '@/components/Text/ch7'
 import TEXTCH8 from '@/components/Text/ch8'
 import TEXTCH9 from '@/components/Text/ch9'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTEPILOGUE from '@/components/Text/epilogue'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/acknowledgments'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTMOREREADING from '@/components/Text/morereading'
 import TEXTINDEX from '@/components/Text/index'
 import TEXTDISCUSSIONGUIDE from '@/components/Text/discussionguide'
 import TEXTENDORSEMENTS from '@/components/Text/endorsements'
 import TEXTABOUTAUTHOR from '@/components/Text/aboutauthor'
 import TEXTMOREFROMIVP from '@/components/Text/morefromIVP'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/photo",
 			"name" : "Text/photo",
 			"component" : TEXTPHOTO
 		},
 		{
 			"path" : "/Text/titlepage",
 			"name" : "Text/titlepage",
 			"component" : TEXTTITLEPAGE
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/dedication",
 			"name" : "Text/dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/epigraphs",
 			"name" : "Text/epigraphs",
 			"component" : TEXTEPIGRAPHS
 		},
 		{
 			"path" : "/Text/prologue",
 			"name" : "Text/prologue",
 			"component" : TEXTPROLOGUE
 		},
 		{
 			"path" : "/Text/ch1",
 			"name" : "Text/ch1",
 			"component" : TEXTCH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js